export var PoiSearchEnum;
(function (PoiSearchEnum) {
    PoiSearchEnum["name"] = "POI name";
    PoiSearchEnum["alternativeName"] = "Alternative name";
    PoiSearchEnum["type"] = "Type";
    PoiSearchEnum["address"] = "Address";
    PoiSearchEnum["ward"] = "Ward";
})(PoiSearchEnum || (PoiSearchEnum = {}));
export var PoiSearchOption;
(function (PoiSearchOption) {
    PoiSearchOption["Poi"] = "POI";
})(PoiSearchOption || (PoiSearchOption = {}));
